// CONFIG
export const COLORS = ["#C6654A", "#D59E5D", "#F8E877", "#97BD76", "#9999F9"];

export function fmt(v: number): string {
    if (v >= 1000) return v.toLocaleString(undefined, { maximumFractionDigits: 0 });
    if (v >= 10) return parseFloat(v.toFixed(1)).toString();
    return parseFloat(v.toFixed(2)).toString();
}
